/** TikTok Shop–style icons */

export function IconClose({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M6 6l12 12M18 6L6 18"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconBack({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M15 5l-7 7 7 7"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconBag({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M6.5 8h11l-.8 11.2a1.5 1.5 0 01-1.5 1.3H8.8a1.5 1.5 0 01-1.5-1.3L6.5 8z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M9 8V6.8A3 3 0 0112 3.8 3 3 0 0115 6.8V8"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconCart({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M3.5 5h1.8l1.4 11.2a1.6 1.6 0 001.6 1.4h9.4a1.6 1.6 0 001.55-1.2L21 8.2H7.2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="9.2" cy="20" r="1.3" fill="currentColor" />
      <circle cx="17.2" cy="20" r="1.3" fill="currentColor" />
    </svg>
  );
}

export function IconShare({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M14 5l7 7-7 7"
        stroke="currentColor"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12H10.5C7 12 4.5 14.2 4.5 17.5V19"
        stroke="currentColor"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconVolume({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M4 10v4h3.2L12 18.5V5.5L7.2 10H4z"
        fill="currentColor"
      />
      <path
        d="M15.2 9.2a3.6 3.6 0 010 5.6M17.8 6.8a7 7 0 010 10.4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconVolumeMuted({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M4 10v4h3.2L12 18.5V5.5L7.2 10H4z"
        fill="currentColor"
      />
      <path
        d="M16 9.5l5 5M21 9.5l-5 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconEmoji({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="9" cy="10" r="1.1" fill="currentColor" />
      <circle cx="15" cy="10" r="1.1" fill="currentColor" />
      <path
        d="M8.5 14.2c1.1 1.4 2.5 2.1 3.5 2.1s2.4-.7 3.5-2.1"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconSearch({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="11" cy="11" r="6.5" stroke="currentColor" strokeWidth="2" />
      <path d="M16.2 16.2L20 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IconShopBag({ size = 40 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden>
      <rect width="48" height="48" rx="14" fill="#EDE4D8" />
      <path
        d="M15 18h18l-1.2 16.5a2 2 0 01-2 1.9H18.2a2 2 0 01-2-1.9L15 18z"
        fill="#662023"
      />
      <path
        d="M19.5 18v-2a4.5 4.5 0 019 0v2"
        stroke="#662023"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <circle cx="24" cy="28" r="2.2" fill="#EDE4D8" />
    </svg>
  );
}

export function IconVoucher({ size = 36 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden>
      <path
        d="M6 14.5c0-2 1.6-3.5 3.5-3.5h29c1.9 0 3.5 1.5 3.5 3.5v6.2c-2.1.4-3.6 2.2-3.6 4.3S39 29.4 41 29.8v6.2c0 2-1.6 3.5-3.5 3.5h-29c-1.9 0-3.5-1.5-3.5-3.5v-6.2c2-.4 3.5-2.2 3.5-4.3S8 21.1 6 20.7v-6.2z"
        fill="#FE2C55"
        fillOpacity="0.12"
        stroke="#FE2C55"
        strokeWidth="2"
      />
      <path
        d="M18 14v22"
        stroke="#FE2C55"
        strokeWidth="2"
        strokeDasharray="3 3"
        strokeLinecap="round"
      />
      <circle cx="12.5" cy="24.5" r="2.2" fill="#FE2C55" />
    </svg>
  );
}

/** Gift box — used for free_gift / BOGO chips */
export function IconGift({ size = 36 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden>
      <rect
        x="8"
        y="20"
        width="32"
        height="20"
        rx="3"
        fill="#FE2C55"
        fillOpacity="0.12"
        stroke="#FE2C55"
        strokeWidth="2"
      />
      <path
        d="M8 28h32"
        stroke="#FE2C55"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 20v20"
        stroke="#FE2C55"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 14c0-2.8 2-4.5 4.2-4.5 2.6 0 3.8 2.4 3.8 4.5H16zM32 14c0-2.8-2-4.5-4.2-4.5C25.2 9.5 24 11.9 24 14h8z"
        fill="#FE2C55"
        fillOpacity="0.18"
        stroke="#FE2C55"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="10"
        y="14"
        width="28"
        height="6"
        rx="2"
        fill="#FE2C55"
        fillOpacity="0.12"
        stroke="#FE2C55"
        strokeWidth="2"
      />
    </svg>
  );
}

export function IconInfo({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 11v5.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="12" cy="8" r="1.15" fill="currentColor" />
    </svg>
  );
}

export function IconViewer({ size = 12 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 5c5.5 0 9.5 5.2 10.4 6.5a1 1 0 010 1C21.5 13.8 17.5 19 12 19S2.5 13.8 1.6 12.5a1 1 0 010-1C2.5 10.2 6.5 5 12 5zm0 3.5A3.5 3.5 0 1015.5 12 3.5 3.5 0 0012 8.5z" />
    </svg>
  );
}
